import React from 'react';

import { Visible } from '../../../core/components';
import { Date as DateComp } from '../../../components';

import Info from './Info';

const OrderInfo = ({ order, manage, open, last, user, client }) => {
  const topBorderClass = order?.items?.length > 1 && open ? 'top-border' : '';
  const orderUser = order?.user || client;

  return (
    <div className={`col-first ${topBorderClass}`}>
      <div className="item-col">
        <Visible when={!manage && false}>
          <Info label="Payment">Will be implemented</Info>
        </Visible>

        {!!order?.reference_number && <Info label="Order">{order?.reference_number}</Info>}
        <Info label="Date">
          <DateComp date={order?.created_at || (new Date()).toUTCString()} />
        </Info>
        <Visible when={user?.is_admin}>
          <Info label="Client">
            {orderUser?.first_name} {orderUser?.last_name}
            <div>
              {orderUser?.phone}
            </div>
          </Info>
        </Visible>
      </div>
    </div>
  );
};

export default OrderInfo;
